import React from "react";
import { useRouter } from 'next/router';
import useSWR from 'swr'
// nodejs library that concatenates classes
import classNames from "classnames";
import dynamic from 'next/dynamic';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Loading from 'components/Functions/Loading';

// @material-ui/icons
const Timeline = dynamic(() => import('@material-ui/lab/Timeline'), { loading: () => <Loading /> });
const TimelineItem = dynamic(() => import('@material-ui/lab/TimelineItem'));
const TimelineSeparator = dynamic(() => import('@material-ui/lab/TimelineSeparator'));
const TimelineConnector = dynamic(() => import('@material-ui/lab/TimelineConnector'));
const TimelineContent = dynamic(() => import('@material-ui/lab/TimelineContent'));
const TimelineDot = dynamic(() => import('@material-ui/lab/TimelineDot'));
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';

const Typography = dynamic(() => import('@material-ui/core/Typography'));
const Paper = dynamic(() => import('@material-ui/core/Paper'));

import { Business } from '@material-ui/icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = dynamic(() => import('/components/Footer/Footer.js'), { loading: () => <Loading /> });

import landingPage from "/styles/jss/bbhost/pages/landingPage.js";
import teamStyle from "/styles/jss/bbhost/pages/landingPageSections/teamStyle.js";
const styles = {
  ...landingPage,
  ...teamStyle,
  textTypo: {
    fontSize: "0.875rem",
    "@media (min-width: 1200px)": {
      fontSize: "1rem",
    },
  },
};

// Sections for this page
import HeaderSection from "pages-sections/HeaderSection.js";
const GridContainer = dynamic(() => import('/components/Grid/GridContainer.js'));

const useStyles = makeStyles(styles);

const SEO = {
  title: "BB Host",
  description: "BB Host Sobre Nós",
  url: "https://www.bbhost.com.br/sobrenos",
  type: "website",
  languageAlternates: [
    {
        hrefLang: 'en',
        href: "https://www.bbhost.com.br/en/sobrenos",
    },
    {
        hrefLang: 'es',
        href: "https://www.bbhost.com.br/es/sobrenos",
    }
  ],
};

const fetcher = (url) => fetch(url).then((res) => res.json());

export default function AboutUS(props) {
  const classes = useStyles();
  const { locale } = useRouter();
  const { data: dataAboutUS } = useSWR('https://api-frontend-site.bbhost.com.br/about-us', fetcher)
  let timelineItems = <></>
  if(dataAboutUS) {
    timelineItems = dataAboutUS.map((item, key) => {
      let iconStyle = {};
      let icon = (
        <TimelineDot color="primary">
          <Business />
        </TimelineDot>
      );
      let timelineDot = {};
      if(Array.isArray(item.icon.code)) {
        if(item.icon.style !== undefined)
          iconStyle = item.icon.style;
        if(item.icon.style.color === undefined)
          timelineDot = {"color":"primary"};
        icon = (
          <TimelineDot {...timelineDot}>
            <FontAwesomeIcon icon={item.icon.code} {...iconStyle} />
          </TimelineDot>
        );
      }
      return (
        <TimelineItem key={key}>
          <TimelineOppositeContent>
            <Typography variant="body2" color="textSecondary">
              {item.year}
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            {icon}
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={8} className={classes.paper} style={{padding: "4%"}}>
              <Typography align="center" className={classes.textTypo}>
                {item.html.map((text)=>{
                  return <>{text}<br/><br/></>;
                })}
              </Typography>
            </Paper>
          </TimelineContent>
        </TimelineItem>
      );
    });
  }
  return (
    <div>
      <HeaderSection name="about_us" seo={SEO} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <div className={classes.section}>
            <GridContainer justifyContent="center" alignItems="center">
                <Timeline align="alternate">
                  {timelineItems}
                </Timeline>
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export async function getServerSideProps({ req, res }) {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=86400, stale-while-revalidate=86400'
  );
  return {
    props: {}
  }
}